import React from "react";
import { Link } from "react-router-dom";
import acuadori_icon from '../assets/acuadori.ico'
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap'
import acuadori_header from '../assets/acuadori_header.png'



export class NavBarComponent extends React.Component {

    static defaultProps = {
        elements: [
            {
                path: '/home', label: 'Home', dropdown: false
            },
            {
                path: '', label: 'Field', dropdown: true, dropdownItems: [
                    { path: '/addField', label: 'New Field' },
                    { path: '/assignField', label: 'Assign Field' }
                ]
            },
            {
                path: '', label: 'Device', dropdown: true, dropdownItems: [
                    { path: '/addDevice', label: 'New Device' },
                    { path: '/addDeviceMeteo', label: 'New Device Meteo' },
                    { path: '/loraWanDevice', label: 'LoraWAN Device' },
                    { path: '/deviceHistory', label: 'Device History' }
                ]
            },
            {
                path: '', label: 'Customer', dropdown: true, dropdownItems: [
                    { path: '/addCustomer', label: 'New Customer' }
                ]
            },
            {
                path: '', label: 'Dashboard', dropdown: true, dropdownItems: [
                    { path: '/generateDashboard', label: 'New Dashboard' },
                    { path: '/assignDashboard', label: 'Assign Dashboard' }
                ]
            },
            // {
            //     path: '', label: 'Docs', dropdown: true, dropdownItems: [
            //         { path: '/docs/Acua-SMART IOT platform', label: 'Acuadori Doc' }
            //     ]
            // }
        ]

    };


    constructor(props) {
        super(props);
        this.state = {
            navExpanded: false
        }
    }

    renderAcuadoriIcon = (alternate, value, path) => {
        return (
            <>
                <img src={acuadori_icon} alt={alternate} /> {value}
            </>
        )
    }

    closeNav = () => {
        this.setState({ navExpanded: false });
    }
    render() {
        let { elements } = this.props;
        if (!elements) {
            return null;
        }
        return (
            <Container className={this.props.bg}>
                <Navbar collapseOnSelect className={'d-flex justify-content-center'} bg={this.props.bg} expand='md'>
                    <Navbar.Brand>
                        <img
                            src={acuadori_header}
                            height={96}
                            width={210}
                            alt={'Acuadori_icon'}
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle
                        aria-controls='#navbar'
                        className='border-0'>
                        {this.renderAcuadoriIcon('menu', <span className='text-secondary'>Menu</span>)}
                    </Navbar.Toggle>
                    <Navbar.Collapse id='navbar'>
                        <Nav className={'mr-auto d-flex justify-content-center'}>
                            {
                                elements.map(element => {
                                    if (!!element.dropdown) {
                                        return (
                                            <NavDropdown className={'d-flex justify-content-center'} title={element.label} id='navbar'>
                                                {element.dropdownItems.map(item => {
                                                    return (
                                                        <NavDropdown.Item className={'d-flex justify-content-center'}>
                                                            <Link className="btn btn-outline-primary" key={item.label} to={item.path} onClick={this.closeNav} >
                                                                <img src={acuadori_icon} alt={element.label} />{item.label}
                                                            </Link>
                                                        </NavDropdown.Item>
                                                    );
                                                })}
                                            </NavDropdown>
                                        );
                                    } else {
                                        return (
                                            <Nav.Item className={'d-flex justify-content-center'} >
                                                <Link className="btn btn-outline-primary" key={element.label} to={element.path} onClick={this.closeNav} >
                                                    <img src={acuadori_icon} alt={element.label} /> {element.label}
                                                </Link>
                                            </Nav.Item>
                                        );
                                    }
                                })
                            }
                            <Nav.Item className={'d-flex justify-content-center'} >
                                <button className="btn btn-outline-danger m-1" type='submit' onClick={this.props.callBack} hidden={this.props.hidden}>
                                    Logout
                                </button>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        );
    }
}
